import { Component } from '@angular/core';

@Component({
  selector: 'app-organization-webhooks',
  templateUrl: './organization-webhooks.component.html',
  styleUrls: ['./organization-webhooks.component.scss'],
})
export class OrganizationWebhooksComponent {}
